import moment from "moment";
import {
  DO_APPLY_SEARCH,
  DO_APPLY_SEARCH_MAPS,
  DO_CANCEL_APPLY_JOB,
  DO_GET_LIST,
  DO_GET_LIST_APPLY,
  DO_GET_LIST_PLAN,
  DO_GET_LIST_RESULT_EMPLOYMENT,
  DO_GET_LIST_RESULT_SALARY,
  DO_GET_LIST_WORK,
  DO_GET_WISH_LIST,
  DO_RESET_DEFAULT,
  RESET_JOBS,
  SHOW_JOBS,
} from "@actionTypes/jobs";
import { DATE_FORMAT } from "@config/constants";

const dayDefault = moment().add(1, "days").format(DATE_FORMAT.toUpperCase());

export const initialParams = {
  pref_id: "",
  city_id: "",
  start_date: dayDefault,
  end_date: dayDefault,
  mst_business_id: [],
  job_condition_id: [],
  freeword: "",
  page: 1,
  cityOptions: [{ id: 1 }],
};

const initialParamsMap = {
  latitude: 0,
  longitude: 0,
  working_day: dayDefault,
  shift_pattern_names: [],
};

const initialParamsJobsResult = {
  start_date: null,
  end_date: null,
};

const initialParamsWishlist = {
  date: moment().format(DATE_FORMAT.toUpperCase()),
};

const initialState = {
  offer: {
    search: initialParams,
    searchMap: initialParamsMap,
    meta: {},
  },
  wishlist: {
    params: initialParamsWishlist,
    meta: {},
  },
  apply: {
    meta: {},
  },
  plan: {
    meta: {},
  },
  work: {
    meta: {},
  },
  resultEmployment: {
    params: initialParamsJobsResult,
    meta: {},
  },
  resultSalary: {
    params: initialParamsJobsResult,
    meta: {},
  },
  showListOffer: false,
  showQuickSearch: false,
  showFeature: false,
};

const reducer = (state = initialState, { type, payload, params = null } = {}) => {
  switch (type) {
    case DO_APPLY_SEARCH:
      return doApplySearch(state, payload);
    case DO_APPLY_SEARCH_MAPS:
      return doApplySearchMap(state, payload);
    case DO_GET_LIST:
      return getMeta(state, payload, params);
    case DO_GET_WISH_LIST:
      return getWishList(state, payload, params);
    case DO_GET_LIST_APPLY:
      return getListApply(state, payload, params);
    case DO_GET_LIST_PLAN:
      return getListPlan(state, payload, params);
    case DO_GET_LIST_WORK:
      return getListWork(state, payload, params);
    case DO_GET_LIST_RESULT_EMPLOYMENT:
      return getListResultEmployment(state, payload, params);
    case DO_GET_LIST_RESULT_SALARY:
      return getListResultSalary(state, payload, params);
    case DO_CANCEL_APPLY_JOB:
      return state;
    case SHOW_JOBS:
      return showJobs(state, payload);
    case RESET_JOBS:
      return resetJobs(state, payload);
    case DO_RESET_DEFAULT:
      return initialState;
    default:
      return state;
  }
};

function doApplySearch(state, payload) {
  const offer = { ...state.offer };
  offer.search = payload.params;
  offer.meta = payload.meta || offer.meta;

  return { ...state, showListOffer: payload.showListOffer ?? true, offer, showQuickSearch: false };
}

function doApplySearchMap(state, payload) {
  const offer = { ...state.offer };
  offer.searchMap = payload.params;
  offer.meta = {};

  return { ...state, offer };
}

function getMeta(state, payload) {
  const offer = { ...state.offer };
  offer.meta = payload.meta;

  return { ...state, showListOffer: true, offer };
}

function getWishList(state, payload) {
  const wishlist = { ...state.wishlist };
  wishlist.params = payload.params;
  wishlist.meta = payload.meta;

  return { ...state, wishlist };
}

function getListApply(state, payload) {
  const apply = { ...state.apply };
  apply.meta = payload.meta;

  return { ...state, apply };
}

function getListPlan(state, payload) {
  const plan = { ...state.plan };
  plan.meta = payload.meta;

  return { ...state, plan };
}

function getListWork(state, payload) {
  const work = { ...state.work };
  work.meta = payload.meta;

  return { ...state, work };
}

function getListResultEmployment(state, payload) {
  const resultEmployment = { ...state.resultEmployment };
  resultEmployment.params = payload.params;
  resultEmployment.meta = payload.meta;

  return { ...state, resultEmployment };
}

function getListResultSalary(state, payload) {
  const resultSalary = { ...state.resultSalary };
  resultSalary.params = payload.params;
  resultSalary.meta = payload.meta;

  return { ...state, resultSalary };
}

function showJobs(state, payload) {
  const offer = { ...state.offer };
  const wishlist = { ...state.wishlist };
  offer.meta = payload?.hasShow ? offer.meta : {};
  wishlist.meta = {};

  return {
    ...state,
    offer,
    wishlist,
    showListOffer: payload?.hasShow,
    showQuickSearch: true,
    showFeature: payload?.hasShow,
  };
}

function resetJobs(state, payload) {
  const offer = payload.reset ? { ...initialState.offer } : { ...state.offer };
  const wishlist = { ...state.wishlist };
  wishlist.meta = {};

  return { ...initialState, offer, wishlist, showListOffer: state.showListOffer };
}

export default reducer;
